export default __webpack_public_path__ + "static/media/service_types.1d26f0fc.png";